<template>
  <div class="custom-container">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div class="melding page-wrapp">
      <div v-if="post" class="content">
        <p class="date">Publisert: {{ date }}</p>
        <p class="title">{{ post.title }}</p>
        <p v-for="block in content" :key="block._id">
          {{ block }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import './Melding.scss';

const query = `*[slug.current == $slug] {
	_updatedAt,
	title,
  slug,
  content,
}[0]
`;

export default {
  name: 'Melding',
  components: {},

  data() {
    return {
      loader: false,
      post: [],
      content: [],
      date: '',
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.error = this.post = null;
      this.loader = true;

      this.$sanity.fetch(query, { slug: this.$route.params.slug }).then(
        (post) => {
          this.loader = false;
          this.post = post;
          this.content = post.content.split('\n\n');
          const d = new Date(post._updatedAt);
          const day = d.getDate();
          const month = d.getMonth() + 1;
          const year = d.getFullYear() - 2000;
          this.date = `${day}.${month}.${year}`;
        },
        (error) => {
          this.error = error;
        }
      );
    },
  },
};
</script>
